/** @format */

import React, { FunctionComponent } from 'react';
import MvnoBlockRequestState from '../../interfaces/platform/MvnoBlockRequestState';
import MvnoBlockRequest from '../../interfaces/platform/MvnoBlockRequest';
import MvnoBlockFunction from '../../interfaces/platform/MvnoBlockFunction';
import OperationOnServiceView from './Locale/OperationOnServiceView';

export type LocalViewObjectType = {
    mvnoBlockRequest: MvnoBlockRequest;
    stateBlock: MvnoBlockRequestState;
    mvnoBlockFunction: MvnoBlockFunction;
    viewDialog(title: any | string | null, content: any | null): void;
};

export const LocalViewObject: FunctionComponent<LocalViewObjectType> = ({ mvnoBlockRequest, mvnoBlockFunction, stateBlock, viewDialog }) => {
    switch (mvnoBlockFunction.functionName) {
        case 'Adescom\\Block\\Operations\\OperationOnService':
            return (
                <OperationOnServiceView
                    mvnoBlockRequest={mvnoBlockRequest}
                    stateBlock={stateBlock}
                    mvnoBlockFunction={mvnoBlockFunction}
                    viewDialog={viewDialog}
                />
            );
        default:
            return null;
    }
};
